// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Lm-z","badgeLink":"Mm-z","category":"Nm-z"};